import { defineMessages } from 'react-intl';

export const userManagementMessages = defineMessages({
    title: {
        id: 'user-management',
        defaultMessage: 'User management',
    },
    user: {
        id: 'user',
        defaultMessage: 'User',
    },
    users: {
        id: 'users',
        defaultMessage: 'Users',
    },
    invitation: {
        id: 'invitation',
        defaultMessage: 'Invitation',
    },
    invitations: {
        id: 'user-management-invitations',
        defaultMessage: 'Invitations',
    },
    parkingMemberships: {
        id: 'user-management-memberships',
        defaultMessage: 'Parking memberships',
    },
    memberships: {
        id: 'memberships',
        defaultMessage: 'Memberships',
    },
    membership: {
        id: 'membership',
        defaultMessage: 'Membership',
    },
    roleOwner: {
        id: 'user-management-role-owner',
        defaultMessage: 'Owner',
    },
    roleOperator: {
        id: 'user-management-role-operator',
        defaultMessage: 'Operator',
    },
    roleViewer: {
        id: 'user-management-role-viewer',
        defaultMessage: 'Viewer',
    },
    roleClient: {
        id: 'user-management-role-client',
        defaultMessage: 'Client',
    },
    roleValidator: {
        id: 'user-management-role-validator',
        defaultMessage: 'Validator',
    },
    roleFinance: {
        id: 'user-management-role-finance',
        defaultMessage: 'Finance',
    },
    roleParkingManager: {
        id: 'user-management-role-parking-manager',
        defaultMessage: 'Parking manager',
    },
    roleReception: {
        id: 'user-management-role-reception',
        defaultMessage: 'Reception',
    },
    roleSalesManager: {
        id: 'user-management-role-sales-manager',
        defaultMessage: 'Sales manager',
    },
    roleReceptionManager: {
        id: 'user-management-role-reception-manager',
        defaultMessage: 'Reception manager',
    },
    ubbReservations: {
        id: 'user-management-role-ubb-reservations',
        defaultMessage: 'Reception manager',
    },
    name: {
        id: 'name',
        defaultMessage: 'Name',
    },
    email: {
        id: 'email',
        defaultMessage: 'Email',
    },
    role: {
        id: 'role',
        defaultMessage: 'Role',
    },
    rolePlaceholder: {
        id: 'role-placeholder',
        defaultMessage: 'Choose a role',
    },
    status: {
        id: 'status',
        defaultMessage: 'Status',
    },
    statusActive: {
        id: 'active',
        defaultMessage: 'Active',
    },
    statusInactive: {
        id: 'inactive',
        defaultMessage: 'Inactive',
    },
    newUserDescription: {
        id: 'new-user-description',
        defaultMessage:
            'Creating an invitation will send an email to the provided recipient. After that the invitee will need to open the link and complete their registration.',
    },
    membershipInvitations: {
        id: 'membership-invitations',
        defaultMessage: 'Membership invitations',
    },
    membershipInvitationCreateSuccess: {
        id: 'membership-invitation-create-success',
        defaultMessage: 'Membership invitation created',
    },
    membershipInvitationCreateSuccessDetails: {
        id: 'membership-invitation-create-success-details',
        defaultMessage: 'Membership invitation successfully created for user with email {email}',
    },
    invitedBy: {
        id: 'invited-by',
        defaultMessage: 'Invited by',
    },
    expires: {
        id: 'expires',
        defaultMessage: 'Expires',
    },
    deleteInvitation: {
        id: 'delete-invitation',
        defaultMessage: 'Delete invitation',
    },
    deleteInvitationFor: {
        id: 'delete-invitation-for',
        defaultMessage: 'Delete invitation for {email}',
    },
    confirmDeleteInvitation: {
        id: 'confirm-delete-invitation',
        defaultMessage: 'Are you sure you want to delete the invitation for {email}? This action cannot be undone.',
    },
    deleteInvitationSuccess: {
        id: 'delete-invitation-success',
        defaultMessage: 'Invitation deleted',
    },
    deleteInvitationSuccessDetails: {
        id: 'delete-invitation-success-details',
        defaultMessage: 'Invitation for email {email} successfully deleted',
    },
    resendInvitation: {
        id: 'resend-invitation',
        defaultMessage: 'Resend invitation',
    },
    resendInvitationTo: {
        id: 'resend-invitation-to',
        defaultMessage: 'Resend invitation to {email}',
    },
    confirmResendInvitation: {
        id: 'confirm-resend-invitation',
        defaultMessage: 'Are you sure you want to resend the invitation for {email}?',
    },
    resendInvitationSuccess: {
        id: 'resend-invitation-success',
        defaultMessage: 'Invitation resent',
    },
    resendInvitationSuccessDetails: {
        id: 'resend-invitation-success-details',
        defaultMessage: 'Invitation for email {email} successfully resent',
    },
    validationType: {
        id: 'validation-type',
        defaultMessage: 'Validation type',
    },
    guest: {
        id: 'guest',
        defaultMessage: 'Guest',
    },
    pricingPlan: {
        id: 'pricing-plan',
        defaultMessage: 'Pricing Plan',
    },
    pricingPlanValidation: {
        id: 'pricing-plan-validation',
        defaultMessage: 'Validation pricing plan',
    },
    editMembership: {
        id: 'edit-membership',
        defaultMessage: 'Edit membership',
    },
    deactivated: {
        id: 'deactivated',
        defaultMessage: 'Deactivated',
    },
    userDeactivated: {
        id: 'user-deactivated',
        defaultMessage: 'Deactivated',
    },
    userActivated: {
        id: 'user-activated',
        defaultMessage: 'Activated',
    },
    changeMembershipStatusConfirmation: {
        id: 'change-membership-status-confirmation',
        defaultMessage: 'Are you sure you want to {status} user {name}?',
    },
    activateUser: {
        id: 'activate-user',
        defaultMessage: 'Activate',
    },
    deactivateUser: {
        id: 'deactivate-user',
        defaultMessage: 'Deactivate',
    },
    userStatusChanged: {
        id: 'user-status-changed',
        defaultMessage: 'Successfully {status}',
    },
    userStatusChangedDescription: {
        id: 'user-status-changed-description',
        defaultMessage: '{name} has successfully been {status}',
    },
    editUser: {
        id: 'edit-user',
        defaultMessage: 'Edit user',
    },
    clients: {
        id: 'clients',
        defaultMessage: 'Clients',
    },
    filterByLabel: {
        id: 'filter-by-label',
        defaultMessage: 'Filter by {value}',
    },
    invitationActive: {
        id: 'invitation-active',
        defaultMessage: 'Active',
    },
    invitationExpired: {
        id: 'invitation-expired',
        defaultMessage: 'Expired',
    },
    guestReasons: {
        id: 'guest-reasons',
        defaultMessage: 'Guest reasons',
    },
});
